import useSWR, { SWRResponse } from 'swr';
import { consignmentService } from 'services';
import { useAuth } from 'hooks';
import { ONE_SECOND_MILLISECONDS } from 'commons';

const SECONDS_TO_REFRESH = 70;
const REFRESH_INTERVAL = SECONDS_TO_REFRESH * ONE_SECOND_MILLISECONDS;

export function useUpdateConsignments(): SWRResponse<number, any> {
  const { selectedStore } = useAuth();
  const store = selectedStore.name || '';

  const response = useSWR(
    store ? `last-modification-${store}` : null,
    () =>
      consignmentService.getLastModification({
        store,
        seconds: SECONDS_TO_REFRESH,
      }),
    {
      refreshInterval: REFRESH_INTERVAL,
      refreshWhenHidden: true,
      revalidateOnMount: false,
      revalidateOnFocus: false,
    }
  );

  return response;
}
